/* eslint-disable no-use-before-define */
import React, { useEffect, useState } from "react";
import { useLocation, matchPath, useHistory } from "react-router-dom";
import PerfectScrollbar from "react-perfect-scrollbar";
import PropTypes from "prop-types";
import {
  Box,
  Drawer,
  Hidden,
  List,
  ListSubheader,
  makeStyles,
} from "@material-ui/core";
import {
  FaTachometerAlt,
  FaUserAlt,
  FaCommentAlt,
} from "react-icons/fa";
import { AiFillPicture } from "react-icons/ai";
import { RiLayoutGridFill } from "react-icons/ri";
import { AiFillRobot } from "react-icons/ai";
import { IoCall } from "react-icons/io5";
import { FaRegIdCard } from "react-icons/fa";
import NavItem from "./NavItem";
import SubscriptionsIcon from "@material-ui/icons/Subscriptions";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import { siideBarIcon } from "../../../utils";

const sections = [
  {
    items: [
      {
        title: "Dashboard",
        icon: siideBarIcon.dashboard,
        href: "/dashboard",
      },

      {
        title: "Division",
        icon: siideBarIcon.division,
        href: "/users",
      },
      {
        title: "Warehouse",
        icon: siideBarIcon.warehouse,
        href: "/categoryMgmt",
      }, ,
      {
        title: "Parts",
        icon: siideBarIcon.parts,
        href: "/activityMgmt",
      },

      {
        title: "Inventory",
        icon: siideBarIcon.inventory,
        href: "/resouceMgmt",
      },
      {
        title: "Logshipment",
        icon: siideBarIcon.logshipment,
        href: "/emergencyMgmt",
      },
      {
        title: "Technician",
        icon: siideBarIcon.technician,
        href: "/bannerMgmt",
      },
      {
        title: "Reconcile Inventory",
        icon: siideBarIcon.inventory,
        href: "/feedbackMgmt",
      },
      {
        title: "Custom Report",
        icon: siideBarIcon.custom,
        href: "/chatbotMgmt",
      }
    ],
  },
];
const sectionsBelow = [
  {
    items: [
      {
        // title: "Logout",
        icon: ExitToAppIcon,
        href: "/terms-and-condition",
      },
      // {
      //   title: "Privacy Policy",
      //   //icon: PieChartIcon,
      //   href: "/privacy-policy",
      // },
    ],
  },
];

function renderNavItems({ items, pathname, depth = 0 }) {
  return (
    <List disablePadding>
      {items.reduce(
        (acc, item) => reduceChildRoutes({ acc, item, pathname, depth }),
        []
      )}
    </List>
  );
}

function reduceChildRoutes({ acc, pathname, item, depth }) {
  const key = item.title + depth;

  if (item.items) {
    const open = matchPath(pathname, {
      path: item.href,
      exact: false,
    });

    acc.push(
      <NavItem
        depth={depth}
        icon={item.icon}
        info={item.info}
        key={key}
        open={Boolean(open)}
        title={item.title}
      >
        {renderNavItems({
          depth: depth + 1,
          pathname,
          items: item.items,
        })}
      </NavItem>
    );
  } else {
    acc.push(
      <NavItem
        depth={depth}
        href={item.href}
        icon={item.icon}
        info={item.info}
        key={key}
        title={item.title}
      />
    );
  }

  return acc;
}

const useStyles = makeStyles((theme) => ({
  mobileDrawer: {
    width: 256,
    boxShadow: "0px 0px 5px black",
    backgroundColor: "#ffdead",
    // boxShadow: "rgb(90 114 123 / 11%) 0px 7px 30px",
  },
  desktopDrawer: {
    width: 256,
    top: 0,
    boxShadow: "0px 0px 5px black",
    height: "100%",
    backgroundColor: "red",
    // boxShadow: "0px 0px 5px black",
  },
  avatar: {
    cursor: "pointer",
    width: 64,
    height: 64,
  },
  socialIcon: {
    cursor: "pointer",
    marginRight: 5,
  },
  logoicon: {
    display: "flex",
    marginTop: "16px",
    alignItems: "center",
    justifyContent: "center",
  },
  logoutbutton: {
    justifyContent: "space-between",
    paddingLeft: 10,
    borderRadius: 0,
    width: "60px",
    textAlign: "center",
  },
}));

const NavBar = ({ onMobileClose, openMobile }) => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const classes = useStyles();
  const location = useLocation();
  const history = useHistory();
  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const content = (
    <Box height="100%" display="flex" flexDirection="column">
      {/* <Hidden mdDown> */}
      <Box padding={0} className={classes.logoicon}>
      </Box>
      {/* </Hidden> */}
      <PerfectScrollbar options={{ suppressScrollX: true }}>
        <Box py={2}>
          {sections.map((section, i) =>
            // <List
            //   key={`menu${i}`}
            //   subheader={
            //     <ListSubheader disableGutters disableSticky>
            //       {section.subheader}
            //     </ListSubheader>
            //   }
            // >

            //   {renderNavItems({
            //     items: section.items,
            //     pathname: location.pathname,
            //   })}
            // </List>
            <div>
              <span>{section.icon}</span>
              <span>{section.title}</span>
            </div>
          )}
        </Box>
        <Box className="side_nev_Bottom">
          {sectionsBelow.map((section, i) => (
            <List
              key={`menu${i}`}
              subheader={
                <ListSubheader disableGutters disableSticky>
                  {section.subheader}
                </ListSubheader>
              }
            >
              {/* {section.items.map((itemList, i) => {
                return (
                  <Box align="left">
                    <Button
                      fullWidth
                      color="primary"
                      startIcon={
                        <IoLogOutOutline
                          style={{
                            fontSize: "40px",
                            color: "#FAA43C",
                          }}
                        />
                      }
                      key={i}
                      className={classes.logoutbutton}
                      style={{}}
                      onClick={handleClickOpen}
                    >
                      {itemList.title}
                    </Button>

                    <Dialog
                      open={open}
                      fullWidth
                      maxWidth="sm"
                      onClose={handleClose}
                      aria-labelledby="alert-dialog-title"
                      aria-describedby="alert-dialog-description"
                    >
                      <Typography
                        variant="h2"
                        align="center"
                        style={{ fontSize: "24px" }}
                      >
                        Logout
                      </Typography>
                      <DialogContent>
                        <DialogContentText
                          id="alert-dialog-description"
                          align="center"
                        >
                          Are you sure you want to logout?sssss
                        </DialogContentText>
                      </DialogContent>
                      <DialogActions>
                        <Button
                          onClick={handleClose}
                          variant="contained"
                          style={{border:"1px solid #fff"}}
                          color="primary"
                        >
                          No
                        </Button>
                        <Button
                          variant="contained"
                          color="primary"
                          style={{border:"1px solid #fff"}}
                          // onClick={handleClose}
                          onClick={()=>{
                            history.push({pathname:'./'})
                          }}
                          autoFocus
                        >
                          Yes
                        </Button>
                      </DialogActions>
                    </Dialog>
                  </Box>
                );
              })} */}


              {/*  {
        title: "Content Management",
        icon: RiLayoutRowFill,
        href: "/contentMgmt",
      }, */}



            </List>
          ))}
        </Box>
      </PerfectScrollbar>
    </Box>
  );

  return (
    <>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          classes={{ paper: classes.mobileDrawer }}
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
        >
          {content}
        </Drawer>
      </Hidden>
      {/* <Hidden mdDown>
        <Drawer
          anchor="left"
          classes={{ paper: classes.desktopDrawer }}
          open
          variant="persistent"
        >
          {content}
        </Drawer>
      </Hidden> */}
    </>
  );
};

NavBar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool,
};

export default NavBar;
